<template>
  <div class="box">
    <div class="left" @click="select(1)">
      <!-- <div class="chinese">中泽宇华</div>
      <div class="english">ZHONGZE YUHUA TECHNOLOGY</div> -->
      <img src="../../assets/logo02.png" alt="logo" />
    </div>
    <div class="right">
      <!-- <div :class="active == 1 ? 'col' : ''" @click="select(1)">
        <div class="chinese" id="chinese">
          <div :class="active == 1 ? 'imgSrc1' : 'imgSrc2'"></div>
          <div>首页</div>
        </div>
        <div class="english">Home Page</div>
      </div>
      <div :class="active == 2 ? 'col' : ''" @click="select(2)">
        <div class="chinese">关于我们</div>
        <div class="english">About Us</div>
      </div>
      <div :class="active == 3 ? 'col' : ''" @click="select(3)">
        <div class="chinese">业务板块</div>
        <div class="english">Business Unit</div>
      </div>
      <div :class="active == 4 ? 'col' : ''" @click="select(4)">
        <div class="chinese">动态资讯</div>
        <div class="english">Dynamic Information</div>
      </div>
      <div :class="active == 5 ? 'col' : ''" @click="select(5)">
        <div class="chinese">联系我们</div>
        <div class="english">Contact Us</div>
      </div> -->
      <div :class="active == 1 ? 'col' : ''" @click="select(1)">
        <div class="chinese" id="chinese">
          <div :class="active == 1 ? 'imgSrc1' : 'imgSrc2'"></div>
          <div>首页</div>
        </div>
      </div>
      <div :class="active == 2 ? 'col' : ''" @click="select(2)">
        <div class="chinese">产品中心</div>
      </div>
      <div :class="active == 3 ? 'col' : ''" @click="select(3)">
        <div class="chinese">关于我们</div>
      </div>
      <div :class="active == 4 ? 'col' : ''" @click="select(4)">
        <div class="chinese">行业新闻</div>
      </div>
      <div :class="active == 5 ? 'col' : ''" @click="select(5)">
        <div class="chinese">培训</div>
      </div>
      <div :class="active == 6 ? 'col' : ''" @click="select(6)">
        <div class="chinese">市场合作</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: null,
    };
  },
  created() {
    this.active = this.$store.state.menu;
    document.documentElement.scrollTop = 0;
  },
  mounted() {},

  methods: {
    select(a) {
      this.$store.commit("setMeun", a);
      this.active = this.$store.state.menu;

      // switch (a) {
      //   case 1:
      //     this.$router.push({ path: "/home" });
      //     break;
      //   case 2:
      //     this.$router.push({ path: "/aboutUs" });
      //     break;
      //   case 3:
      //     this.$router.push({ path: "/businessUnit" });
      //     break;
      //   case 4:
      //     this.$router.push({ path: "/dynamicInformation" });
      //     break;
      //   case 5:
      //     this.$router.push({ path: "/contactUs" });
      //     break;
      // }

      switch (a) {
        case 1:
          this.$router.push({ path: "/home" });
          break;
        case 2:
          this.$router.push({ path: "/businessUnit" });
          break;
        case 3:
          this.$router.push({ path: "/aboutUs" });
          break;
        case 4:
          this.$router.push({ path: "/dynamicInformation" });
          break;
        case 5:
          this.$router.push({ path: "/training" });
          break;
        case 6:
          this.$router.push({ path: "/contactUs" });
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  min-width: 900px;
  height: 100px;
  // box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  margin: auto;
  padding: 0 50px;
  .left {
    cursor: pointer;
    .chinese {
      font-size: 31px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      line-height: 35px;
      text-align: center;
      letter-spacing: 10px;
    }
    .english {
      font-size: 10px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      line-height: 35px;
    }
  }
  .right {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    user-select: none;
    > div {
      padding: 0 20px;
      text-align: center;
      cursor: pointer;
    }
    > div:nth-child(6) {
      padding: 0 0 0 20px;
    }
    .chinese {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 30px;
    }
    // .english {
    //   font-size: 12px;
    //   font-family: Microsoft YaHei;
    //   font-weight: bold;
    //   line-height: 30px;
    // }
    .col {
      color: #008cd7;
    }
    .imgSrc1 {
      width: 14px;
      height: 13px;
      background-image: url("../../assets/images/header/blue.png");
      background-repeat: no-repeat;
      padding-left: 2px;
    }
    .imgSrc2 {
      width: 14px;
      height: 13px;
      background-image: url("../../assets/images/header/black.png");
      background-repeat: no-repeat;
      padding-left: 2px;
    }
    #chinese {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
